export default visibility => ({visibility});
